/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "letter-minus-2add3a3f--sprite",
  "use": "letter-minus-2add3a3f--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"letter-minus-2add3a3f--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-194.644 -34.082)\"><path d=\"M220.692,48.186v3.4h-.021a6.209,6.209,0,0,0-6.2,6.2H203.76a2.122,2.122,0,0,1-2.116-2.116V48.188a.536.536,0,0,1,.529-.529.5.5,0,0,1,.3.1l8.7,5.8,8.709-5.8a.517.517,0,0,1,.72.133l.01.015A.536.536,0,0,1,220.692,48.186Z\" fill=\"currentColor\" /><path d=\"M219.241,46.052l-8.07,5.38-8.07-5.38a.529.529,0,0,1,.293-.969H218.95a.529.529,0,0,1,.291.969Z\" fill=\"currentColor\" /><path d=\"M220.7,52.961h-.03a4.825,4.825,0,1,0,.03,0Zm2.17,5.36h-4.29a.536.536,0,0,1-.05-1.07.045.045,0,0,1,.05,0h4.24a.524.524,0,0,1,.56.51A.537.537,0,0,1,222.866,58.321Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
